import React, { useState } from 'react';

const Tours = () => {
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    email: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus({ type: '', message: '' });

    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${API_URL}/api/tour-request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setFormStatus({
          type: 'success',
          message: 'Thank you! I\'ll be in touch soon to discuss bringing this to life.'
        });
        setFormData({ name: '', location: '', email: '', message: '' });
      } else {
        setFormStatus({
          type: 'error',
          message: data.message || 'Something went wrong. Please try again.'
        });
      }
    } catch (error) {
      setFormStatus({
        type: 'error',
        message: 'Unable to send request. Please email me directly.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {/* Page Header */}
      <section className="section-padding" style={{ paddingBottom: '40px' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h1 className="hero-large" style={{ marginBottom: '16px' }}>
              Tours
            </h1>
            <p className="body-large" style={{ lineHeight: '1.8', color: 'var(--text-secondary)' }}>
              Catch me in a city near you. Let's create something unforgettable.
            </p>
          </div>
        </div>
      </section>

      {/* Tour Image */}
      <section style={{ padding: '0 40px 60px' }}>
        <div className="container">
          <div style={{ 
            maxWidth: '900px', 
            margin: '0 auto',
            overflow: 'hidden'
          }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/z730fvdr_Honey%20Sofia%20-%201644-Edit-face%20blur.jpg"
              alt="Honey Sofia Tours"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
          </div>
        </div>
      </section>

      {/* Upcoming Tours Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-primary) !important' }}>
            Upcoming Tours
          </h2>
          
          <div style={{ 
            maxWidth: '800px', 
            margin: '0 auto',
            display: 'grid',
            gap: '32px'
          }}>
            {/* Sydney - Home Base */}
            <div style={{
              borderBottom: '1px solid var(--border-light)',
              paddingBottom: '24px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px' }}>
                <div>
                  <h3 className="heading-2" style={{ marginBottom: '8px', color: 'var(--text-primary) !important' }}>
                    Sydney
                  </h3>
                  <p className="body-regular" style={{ color: 'var(--text-secondary) !important' }}>
                    Currently available
                  </p>
                </div>
                <a 
                  href="/bookings?city=Sydney&dates=Available&location=Incall%20(Sydney)" 
                  className="btn-primary"
                  style={{
                    minWidth: '160px',
                    textDecoration: 'none'
                  }}
                >
                  Book Now
                </a>
              </div>
            </div>

            {/* FMTY Information */}
            <div style={{
              padding: '32px 28px',
              background: 'rgba(90, 30, 43, 0.05)',
              borderLeft: '3px solid var(--burgundy)'
            }}>
              <h3 className="heading-3" style={{ marginBottom: '16px', color: 'var(--text-primary) !important' }}>
                Available for FMTY (Fly Me To You)
              </h3>
              <p className="body-regular" style={{ lineHeight: '1.8', color: 'var(--text-secondary) !important', marginBottom: '20px' }}>
                I'm available to travel to your city for extended encounters. Whether you're seeking a dinner companion for an important event, a weekend getaway, or simply want the luxury of my company in your location, I'm happy to discuss FMTY arrangements.
              </p>
              <p className="body-regular" style={{ lineHeight: '1.8', color: 'var(--text-secondary) !important', marginBottom: '24px' }}>
                FMTY bookings require advance notice and cover travel expenses. For inquiries about availability and rates, please use the booking form below.
              </p>
              <a 
                href="/bookings?city=FMTY&dates=TBD&location=Your%20City" 
                className="btn-primary"
                style={{
                  minWidth: '200px',
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
              >
                Enquire About FMTY
              </a>
            </div>

            {/* Future tours note */}
            <div style={{ textAlign: 'center', padding: '20px 20px 0' }}>
              <p className="body-large" style={{ color: 'var(--text-secondary) !important' }}>
                Tour dates will be announced soon. Follow me on social media for updates.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tour Request Form */}
      <section className="section-padding">
        <div className="container">
          <div style={{ maxWidth: '700px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
                Want me in your city?
              </h2>
              <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
                Let me know where you'd like me to visit. If there's enough interest, I'll make it happen.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">
                  Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="location" className="form-label">
                  Requested Location *
                </label>
                <input
                  type="text"
                  id="location"
                  name="location"
                  className="form-input"
                  placeholder="e.g., Melbourne, Gold Coast"
                  value={formData.location}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Additional Information *
                </label>
                <textarea
                  id="message"
                  name="message"
                  className="form-textarea"
                  placeholder="Tell me about your preferred dates, duration, or any other details..."
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="5"
                ></textarea>
              </div>

              {formStatus.message && (
                <div style={{
                  padding: '16px',
                  marginBottom: '24px',
                  background: formStatus.type === 'success' ? 'rgba(90, 30, 43, 0.1)' : 'rgba(220, 38, 38, 0.1)',
                  border: `1px solid ${formStatus.type === 'success' ? 'var(--burgundy)' : '#dc2626'}`,
                  borderRadius: '0px',
                  color: formStatus.type === 'success' ? 'var(--burgundy)' : '#dc2626',
                  fontSize: '14px',
                  lineHeight: '1.5'
                }}>
                  {formStatus.message}
                </div>
              )}

              <button
                type="submit"
                className="btn-primary"
                disabled={isSubmitting}
                style={{
                  width: '100%',
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer'
                }}
              >
                {isSubmitting ? 'Sending...' : 'Submit Request'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tours;
